<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Personal Evaluado</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <br />
        <h5 class="label-black">Buscar Personal</h5>

        <div class="row">
          <div class="col-12">
            <div class="form-group area custom-area">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="form-group-h col-6">
                      <input id="nombrePersona" name="nombrePersona" class="form-control" placeholder="Nombre" v-model="nombreBusqueda" v-on:keyup.enter="buscarEvaluados" autocomplete="off">
                    </div>
                    <div class="form-group-h col-6">
                      <input id="apellidoPaterno" name="apellidoPaterno" class="form-control" placeholder="No. de Nómina" v-model="numeroNominaBusqueda" v-on:keyup.enter="buscarEvaluados">
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-check">
                      <input class="form-check-input" id="filtrarEvaluados" type="checkbox" v-model="filtrarEvaluados">
                      <label class="form-check-label label-black" for="filtrarEvaluadosCheckbox">Ver solo evaluados</label>
                    </div>
                  </div>
                  </div>
                  <div class="col-3">
                    <div class="row">
                      <div class="form-group col-12">
                        <div class="form-check">
                          <input class="form-check-input" id="tipoDePuestoCheckbox" type="checkbox" v-model="filtroPuesto">
                          <label class="form-check-label label-black" for="tipoDePuestoCheckbox">Tipo de puesto</label>
                        </div>
                        <hr/>
                        <div class="form-check" v-if="filtroPuesto">
                          <input class="form-check-input" id="interinatoCheckbox" type="checkbox" v-model="interinoBusqueda">
                          <label class="form-check-label label-black" for="interinatoCheckbox">Interinato</label>
                        </div>
                        <div class="form-check" v-if="filtroPuesto">
                          <input class="form-check-input" id="baseCheckbox" type="checkbox" vmodel="deBaseBusqueda">
                          <label class="form-check-label label-black" for="baseCheckbox">Base</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <button v-on:click="buscarEvaluados" id="btnBuscarPersonalEvaluado" class="btn btn-custom">&nbsp;&nbsp;&nbsp;Buscar&nbsp;&nbsp;&nbsp;</button>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <h5 class="label-black">Resultados de la búsqueda</h5> <h5 class="label-black" v-if="infoPersonas.length>0">({{infoPersonas.length}})</h5>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover table-sm" id="tablaEvaluados">
              <thead class="thead-custom">
                <tr>
                  <th class="text-center">Id Evaluado</th>
                  <th class="text-center">Nombre</th>
                  <th class="text-center">Puesto</th>
                  <th class="text-center">Departamento</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='infoPersona in infoPersonas'>
                  <td>{{ infoPersona.NumeroNomina }}</td>
                  <td>{{infoPersona.NombreCompleto}}</td>
                  <td>{{infoPersona.Puesto}}</td>
                  <td>{{infoPersona.Seccion}} - {{infoPersona.Departamento}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-info-circle' @click='verDetalle(infoPersona)' title="Ver Evaluaciones"/>
                  </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Layout from '@/components/SIAP/Comun/Plantilla.vue';
import catalogos from '@/../static/js/catalogos'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import axios from 'axios'
  import store from '@/store/index'
import paginacion from '@/../static/js/Paginacion'

export default {
  data() {
    return {
      filtroPuesto: false,//Verifica que el filtro de tipo de contrato esté activado
      nombreBusqueda: "", //Filtro de busqueda de nombre
      numeroNominaBusqueda: "",  //Filtro de busqueda de número de nómina
      interinoBusqueda: false, //Filtro de busqueda para personal interino
      deBaseBusqueda: false, //Filtro de busqueda para personal de base
      infoPersonas: [],
      filtrarEvaluados: true
    }
  },
  components: {
    //Layout
  },
    methods: {
    buscarEvaluados: function (event) {
        if (this.numeroNominaBusqueda != "" && isNaN(this.numeroNominaBusqueda)) {
          $('#alertaNumeroNomina').show();
          return
        }
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false,
          "nombreBusqueda": this.nombreBusqueda,
          "numeroNominaBusqueda": parseInt(this.numeroNominaBusqueda,10),
          "tipoPuestoBusqueda": this.filtroPuesto,
          "interinoBusqueda": this.interinoBusqueda,
          "deBaseBusqueda": this.deBaseBusqueda,
          "baneados": [],
          "filtrarEvaluados": this.filtrarEvaluados,
          "verInactivos": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetPersonas, peticion,comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response.data)
            $("#alertaNumeroNomina").hide();
            this.infoPersonas= response.data.InfoPersonas//transifiere los datos necesarios
            this.mostrarTabla = true
            this.evaluaciones = response.data.evaluaciones//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluados', 10)
            })
            //console.log(paginacion)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      }, verDetalle: function (infoPersona) {
        this.$router.push({
          name: 'DetalleDeEvaluaciones',
          params: { infoPersona: infoPersona }
        })
      },


    },
    mounted: function () {
      //this.buscarEvaluados()
    }

}

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/PersonalEvaluado.vue